import React, { useEffect } from 'react';
import ReactEDSWrapper from '../../../utils/react-eds-wrapper';
import { Button, Dialog } from '@dsi/react-eds';
import { AxiosError } from 'axios';
import api from '../../../api/axiosInstance';
import { useLoader } from '../../../hooks/useLoader';
import { useSwobNotifications } from '../../../hooks/NotificationsProvider';
import ReactDOM from 'react-dom';

export interface DeleteUserDialogProps {
  open: boolean;
  onDelete: () => void;
  onCancel: () => void;
  initialUser: { email: string; role: string; id: string; roles: string[] } | null | undefined;
}

const DeleteUserDialog: React.FC<DeleteUserDialogProps> = ({ open, onDelete, onCancel, initialUser }) => {
  const { showLoader, hideLoader } = useLoader();
  const { addNotifications } = useSwobNotifications();

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  const deleteUser = async () => {
    showLoader();
    try {
      await api.delete(`api/keycloak/users/${initialUser?.id}`);
      onDelete();
      addNotifications([
        {
          title: 'Success',
          icon: 'icon-success',
          description: `User ${initialUser?.email} was successfully deleted!`,
          timestamp: new Date(),
          color: 'green'
        }
      ]);
    } catch (error: unknown) {
      let errorMsg = `An error occurred while deleting the user ${initialUser?.email}.`;
      if (error instanceof AxiosError) {
        errorMsg = error?.response?.data?.message || error?.message;
      }
      addNotifications([
        {
          title: 'Error',
          icon: 'icon-triangle-warning',
          description: errorMsg,
          timestamp: new Date(),
          color: 'red'
        }
      ]);
    } finally {
      setTimeout(() => {
        hideLoader();
      }, 500);
    }
  };

  return ReactDOM.createPortal(
    <ReactEDSWrapper
      component={Dialog}
      show={open}
      onClose={onCancel}
      title="Remove User"
      subtitle="User Management"
      bottom={
        <ReactEDSWrapper
          component={Button}
          variant="primary"
          className="btn primary"
          type="button"
          onClick={() => {
            deleteUser();
          }}
        >
          Remove User
        </ReactEDSWrapper>
      }
    >
      <div>
        You're about to remove this user {initialUser?.email} from the list.
        <br />
        This action is permanent and cannot be undone.
        <br />
        <br />
        Are you sure you want to continue?
      </div>
    </ReactEDSWrapper>,
    document.body
  );
};

export default DeleteUserDialog;
